module.exports = __webpack_public_path__ + "img/mastercard.aa3ea4ad.svg";